import { useEffect, useState } from 'react';

const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsentDismissed';

const useCookieConsent = () => {
    const [isDismissed, setIsDismissed] = useState(() => localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === 'true');

    useEffect(() => {
        if (isDismissed) {
            localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'true');
        }
    }, [isDismissed]);

    const dismiss = () => setIsDismissed(true);

    return { dismiss, isDismissed };
};

export { COOKIE_CONSENT_STORAGE_KEY, useCookieConsent };
